<template>
  <zm-dialog
    v-model="visible"
    :title="$t('billing.zcm.unable_to_purchase')"
    width="500px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="zcm-purchase-blocked-dialog"
    @close="handleClose"
  >
    <div class="zcm-purchase-blocked-dialog__content">
      <p>{{ $t('billing.zcm.domain_restriction_warning') }}</p>
    </div>
    <template #footer>
      <div class="zcm-purchase-blocked-dialog__footer">
        <zm-button type="primary" @click="handleClose">
          {{ $t('common.btn_close') }}
        </zm-button>
      </div>
    </template>
  </zm-dialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';

export default {
  name: 'ZcmPurchaseBlockedDialog',
  mixins: [ConfirmComponent],
  methods: {
    handleClose() {
      this.handleCancel();
    }
  }
};
</script>

<style lang="scss">
.zcm-purchase-blocked-dialog {
  .zcm-purchase-blocked-dialog__content {
    padding: 20px 0;
    
    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.2;
      color: #333;
    }
  }
  
    .zcm-purchase-blocked-dialog__footer {
      padding: 10px 0;
      text-align: right;
    }
}
</style>
